import customSelect from 'custom-select';

document.addEventListener('DOMContentLoaded', () => {
  const customSelects = document.querySelectorAll('[data-custom-select]');
  if (customSelects.length) {
    const instances = customSelect(customSelects);

    // Transfer style attributes from original options to custom options
    instances.forEach((instance) => {
      const container = instance.container;
      const select = container.querySelector('select');
      const options = container.querySelectorAll('.custom-select-option');
      const opener = container.querySelector('.custom-select-opener');

      // Transfer classes from original select to container
      if (select) {
        const originalClasses = select.getAttribute('class');
        if (originalClasses) {
          container.classList.add(...originalClasses.split(' '));
        }

        // Update opener style when selection changes
        select.addEventListener('change', () => {
          const selectedOption = select.options[select.selectedIndex];
          if (selectedOption && opener) {
            const style = selectedOption.getAttribute('style');
            if (style) {
              opener.setAttribute('style', style);
            }
          }
        });
      }

      if (select && options.length) {
        const originalOptions = select.querySelectorAll('option');
        options.forEach((option, index) => {

          if (originalOptions[index]) {
            const originalOption = originalOptions[index];
            const style = originalOption.getAttribute('style');
            const disabled = originalOption.getAttribute('disabled');

            if (style) {
              option.setAttribute('style', style);
              if (originalOption.selected && opener) {
                opener.setAttribute('style', style);
              }
            }
            if (disabled) {
              option.setAttribute('disabled', disabled);
              option.classList.add('disabled');
            }

            // Also transfer any other relevant attributes
            const dataAttributes = originalOption.getAttributeNames()
              .filter(name => name.startsWith('data-'));

            dataAttributes.forEach((attr) => {
              const value = originalOption.getAttribute(attr);
              option.setAttribute(attr, value);
            });
          }
        });
      }

      // Wrap the custom-select-panel in a div
      const panel = container.querySelector('.custom-select-panel');
      if (panel && !panel.parentElement.classList.contains('custom-select-panel-wrapper')) {
        const wrapper = document.createElement('div');
        wrapper.className = 'custom-select-panel-wrapper';
        panel.parentNode.insertBefore(wrapper, panel);
        wrapper.appendChild(panel);
      }
    });
  }
});